import { createFetcherReducer } from '../utils';
import {
  LOADING_FIGURES,
  RECEIVED_FIGURES,
  RECEIVED_FIGURES_FAILED,
} from '../../actions/types';

export default createFetcherReducer(
  LOADING_FIGURES, RECEIVED_FIGURES, RECEIVED_FIGURES_FAILED,
);
